module.exports = __webpack_public_path__ + "static/media/plane02.b4ad233c.gif";